import { defineStore } from 'pinia';

const path = window.location.pathname;
let cardIndex = 0;

// Set selected card based off URL
for (let i = 0; i < content.cards.length; i++) {
  if (path.includes(content.cards[i].url_path)) {
    cardIndex = i;
  }
}

export const useStore = defineStore('main', {
  state: () => {
    return {
      baseUrl,
      content,
      moments,
      showSmallBusinessBanner,
      showSmallBrilliantBanner,
      selectedCard: content.cards[cardIndex],
      selectedTier: content.cards[cardIndex].calculator.tiers[0],
      totalPoints: 0,
    };
  }
});
